import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const DataList = () => (
  <ComponentDocs name="<DataList/>" entry="DataList" propsEntry="DataListProps">
    <ComponentExample
      name="Data List Items"
      import={import("examples/Data/DataList/DataListExample")}
      rawImport={import("examples/Data/DataList/DataListExample?raw")}
    />
    <ComponentExample
      name="Variable Item Widths"
      import={import("examples/Data/DataList/VariableWidthsExample")}
      rawImport={import("examples/Data/DataList/VariableWidthsExample?raw")}
    />
  </ComponentDocs>
);

export default DataList;
